var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgThread = function SvgThread(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.846 7.055c.11.14.159.32.12.493l-.569 2.6c-.05.228.185.41.389.302L3.57 8.971a.559.559 0 0 1 .385-.049c.152.034.306.063.462.086L7.43 5.996a1.75 1.75 0 0 1 1.954-.36 1.89 1.89 0 0 1 1.416-.914v-.023C10.8 2.28 8.382.318 5.4.318S0 2.279 0 4.699c0 .867.31 1.676.846 2.356Zm10.088-.988a.6.6 0 0 1 .6.6v.666a2.6 2.6 0 0 1-2.6 2.6h-.885l.975.976a.6.6 0 0 1-.848.849L5.752 9.333 8.176 6.91a.6.6 0 1 1 .848.849l-.975.975h.884a1.4 1.4 0 0 0 1.4-1.4v-.666a.6.6 0 0 1 .6-.6Z"
  })));
};
export default SvgThread;